// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
export const ROOT_FONT_SIZE = '16px';
export const NAV_BAR_HEIGHT = '54px';
export const NAV_ITEM_INNER_SPACING_X = '8px';
export const NAV_ITEM_PADDING_LEFT = '12px';
export const NAV_ITEM_PADDING_RIGHT = '12px';
export const NAV_ITEM_PADDING_X = '24px';
export const NAV_ITEM_PADDING_Y = '7px';
export const ALERT_FONT_SIZE = '14px';
export const SMALL_CLOSE_BUTTON_SIZE = '8px';
export const MEDIUM_CLOSE_BUTTON_SIZE = '12px';
export const EXTRA_LARGE_CLOSE_BUTTON_SIZE = '36px';
export const CHEVRON_FONT_SIZE = '12px';
export const EMPTY_STATE_PADDING_X = '56px';
export const EMPTY_STATE_PADDING_Y = '20px';
export const DISTANCE_MEASUREMENT_EXTRA_SMALL = '8px';
export const DISTANCE_MEASUREMENT_SMALL = '12px';
export const DISTANCE_MEASUREMENT_MEDIUM = '24px';
export const DISTANCE_MEASUREMENT_LARGE = '32px';
export const DISTANCE_MEASUREMENT_EXTRA_LARGE = '64px';
export const DRAG_HANDLE_HEIGHT = '24px';
export const DRAG_HANDLE_OFFSET_Y = '12px';
export const DRAG_HANDLE_OFFSET_X = '9px';
export const DRAG_HANDLE_WIDTH = '5px';
export const INPUT_FONT_SIZE = '16px';
export const INPUT_SM_FONT_SIZE = '14px';
export const INPUT_BORDER_WIDTH = '1px';
export const INPUT_DEFAULT_PADDING_X = '10px';
export const INPUT_DEFAULT_PADDING_Y = '10px';
export const INPUT_DEFAULT_HEIGHT = '40px';
export const INPUT_SM_HEIGHT = '32px';
export const SLIDER_CONTROL_SIZE = '20px';
export const LABEL_DEFAULT_PADDING_TOP = '8px';
export const LABEL_DEFAULT_PADDING_BOTTOM = '4px';
export const BASE_FONT_SIZE = '14px';
export const BASE_LINE_HEIGHT = '24px';
export const BASE_SINGLE_DIRECTION_MARGIN = '16px';
export const BASE_SPACING_X = '12px';
export const BASE_SPACING_Y = '6px';
export const BASE_ICON_SPACING_X = '8px';
export const INLINE_ICON_SPACING_X = '4px';
export const HEADING1 = '32px';
export const HEADING2 = '24px';
export const HEADING3 = '22px';
export const HEADING4 = '20px';
export const HEADING5 = '16px';
export const HEADING6 = '14px';
export const HEADING7 = '14px';
export const PAGE_TITLE_FONT_SIZE = '20px';
export const MICROCOPY_SIZE = '12px';
export const MICROCOPY_LINE_HEIGHT = '18px';
export const FORM_COPY_SIZE = '16px';
export const FORM_SET_VALIDATION_TOP_SPACING = '4px';
export const FORM_SET_VERTICAL_SEPARATION = '12px';
export const BUTTON_BORDER_WIDTH = '1px';
export const BUTTON_XS_FONT_SIZE = '12px';
export const BUTTON_SM_FONT_SIZE = '12px';
export const BUTTON_DEFAULT_FONT_SIZE = '14px';
export const BUTTON_LG_FONT_SIZE = '44px';
export const BUTTON_DEFAULT_PADDING_X = '24px';
export const BUTTON_DEFAULT_PADDING_Y = '12px';
export const BUTTON_XS_WIDTH = '26px';
export const BUTTON_XS_PADDING_X = '12px';
export const BUTTON_XS_PADDING_Y = '6px';
export const BUTTON_SM_WIDTH = '32px';
export const BUTTON_SM_PADDING_X = '16px';
export const BUTTON_SM_PADDING_Y = '9px';
export const BUTTON_LG_WIDTH = '40px';
export const BUTTON_LG_PADDING_X = '18px';
export const BUTTON_LG_PADDING_Y = '17px';
export const BUTTON_RADIUS = '3px';
export const PAGINATION_BUTTON_FONT_SIZE = '14px';
export const PAGINATION_BUTTON_LABEL_FONT_SIZE = '14px';
export const SELECTABLE_BUTTON_MAX_WIDTH = '200px';
export const SELECTABLE_BUTTON_LARGE_MIN_HEIGHT = '180px';
export const SELECTABLE_BUTTON_SMALL_HEIGHT = '56px';
export const TABLE_DEFAULT_FONT_SIZE = '14px';
export const TABLE_DEFAULT_PADDING_Y = '16px';
export const TABLE_DEFAULT_PADDING_X = '24px';
export const TABLE_CELL_HEIGHT = '72px';
export const TABLE_HEADER_FONT_SIZE = '12px';
export const TABLE_HEADER_PADDING_Y = '14px';
export const TABLE_HEADER_PADDING_TOP = '8px';
export const TABLE_HEADER_PADDING_BOTTOM = '4px';
export const TABLE_HEADER_HEIGHT = '44px';
export const TABLE_COMPACT_PADDING_Y = '8px';
export const TABLE_COMPACT_HEADER_HEIGHT = '56px';
export const TABLE_COMPACT_CELL_HEIGHT = '56px';
export const CARD_PADDING = '40px';
export const CARD_PADDING_COMPACT = '24px';
export const CARD_SHADOW_ALPHA = '.12';
export const CARD_SHADOW_BLUR_RADIUS = '5px';
export const CARD_SHADOW_OFFSET_Y = '1px';
export const ALERT_PADDING = '20px';
export const ALERT_PADDING_X = '20px';
export const ALERT_PADDING_Y = '8px';
export const ALERT_HEIGHT = '60px';
export const DROP_SMALL_HEIGHT = '72px';
export const DROP_LARGE_HEIGHT = '198px';
export const INLINE_DIVIDED_LIST_SPACING_X = '8px';
export const MODAL_HEADER_HEIGHT = '68px';
export const MODAL_HEADER_PADDING_X = '40px';
export const MODAL_BODY_PADDING_X = '40px';
export const MODAL_BODY_PADDING_Y = '40px';
export const MODAL_FOOTER_PADDING_X = '40px';
export const MODAL_FOOTER_PADDING_Y = '24px';
export const MODAL_CLOSE_BUTTON_SIZE = '16px';
export const MODAL_CLOSE_BUTTON_OFFSET = '24px';
export const MODAL_SHORT_HEIGHT = '250px';
export const MODAL_MEDIUM_HEIGHT = '408px';
export const MODAL_TALL_HEIGHT = '700px';
export const MODAL_OVERLAY_PADDING_Y = '60px';
export const MODAL_PANEL_PADDING_X = '40px';
export const MODAL_PANEL_PADDING_Y = '24px';
export const MODAL_PANEL_HEADER_PADDING_Y = '26px';
export const MODAL_PANEL_FOOTER_PADDING_Y = '20px';
export const TEXT_AREA_CODE_HEIGHT = '155px';
export const TOOLBAR_HEIGHT_DARK = '56px';
export const TOOLTIP_MAX_WIDTH = '232px';
export const TOOLTIP_FONT_SIZE = '13px';
export const TOOLTIP_LONGFORM_FONT_SIZE = '12px';
export const TOOLTIP_LONGFORM_PADDING = '20px';
export const TOOLTIP_PADDING = '10px';
export const TOOLTIP_PADDING_Y = '10px';
export const TOOLTIP_PADDING_X = '16px';
export const POPOVER_PADDING_Y = '20px';
export const POPOVER_PADDING_X = '24px';
export const SHEPHERD_PADDING_Y = '16px';
export const DROPDOWN_MENU_HEIGHT = '220px';
export const DROPDOWN_ITEM_DEFAULT_HEIGHT = '40px';
export const DROPDOWN_FONT_SIZE = '14px';
export const DROPDOWN_PADDING_Y = '8px';
export const DROPDOWN_PADDING_X = '20px';
export const DROPDOWN_CARET_OFFSET_X = '16px';
export const TAB_FONT_SIZE = '14px';
export const TAB_INDICATOR_HEIGHT = '5px';
export const TAB_PADDING_Y = '12px';
export const TAB_PADDING_X = '28px';
export const TOGGLE_BUTTON_SIZE = '20px';
export const TOGGLE_BUTTON_SIZE_SMALL = '16px';
export const HEADER_PADDING_TOP = '20px';
export const HEADER_PADDING_BOTTOM = '20px';
export const LAYOUT_MAIN_PADDING_TOP = '20px';
export const LAYOUT_MAX_WIDTH = '1280px';
export const LAYOUT_NARROW_WIDTH = '1140px';
export const LAYOUT_PADDING_X = '48px';
export const LAYOUT_EDITOR_PADDING = '20px';
export const BACK_BUTTON_ARROW_SIZE = '22px';
export const BADGE_FONT_SIZE = '14px';
export const BADGE_ROUNDED_FONT_SIZE = '10px';
export const BADGE_ROUNDED_HEIGHT = '20px';
export const TAG_FONT_SIZE = '12px';
export const TAG_FONT_SIZE_LARGE = '14px';
export const TAG_HEIGHT = '24px';
export const TAG_PADDING_X = '8px';
export const TAG_PADDING_Y = '0';
export const TAG_ICON_SPACING_X = '8px';
export const MERCURY_LAYER = '1';
export const VENUS_LAYER = '2';
export const EARTH_LAYER = '1000';
export const MARS_LAYER = '1070';
export const JUPITER_LAYER = '1111';
export const SATURN_LAYER = '1112';
export const URANUS_LAYER = '1211';
export const AVATAR_SIZE_EXTRA_SMALL = '24px';
export const AVATAR_SIZE_SMALL = '32px';
export const AVATAR_SIZE_MEDIUM = '48px';
export const AVATAR_SIZE_LARGE = '72px';
export const AVATAR_SIZE_EXTRA_LARGE = '110px';
export const BASE_SHADOW_ALPHA = '.08';
export const BASE_SHADOW_BLUR_RADIUS = '24px';
export const BASE_SHADOW_OFFSET_Y = '1px';
export const GRID_BREAKPOINT_SMALL = '544px';
export const GRID_BREAKPOINT_MEDIUM = '768px';
export const GRID_BREAKPOINT_LARGE = '992px';
export const GRID_BREAKPOINT_EXTRA_LARGE = '1200px';
export const DEVICE_FRAME_DESKTOP_WIDTH_RATIO = '16';
export const DEVICE_FRAME_DESKTOP_HEIGHT_RATIO = '10';
export const DEVICE_FRAME_TABLET_WIDTH_RATIO = '3';
export const DEVICE_FRAME_TABLET_HEIGHT_RATIO = '4';
export const DEVICE_FRAME_MOBILE_WIDTH_RATIO = '9';
export const DEVICE_FRAME_MOBILE_HEIGHT_RATIO = '19.5';
export const DEVICE_FRAME_DESKTOP_HEADER_HEIGHT = '23px';
export const DEVICE_FRAME_TABLET_HEADER_HEIGHT = '7%';
export const DEVICE_FRAME_MOBILE_HEADER_HEIGHT = '7%';
export const DEVICE_FRAME_MOBILE_FOOTER_HEIGHT = '7%';
export const DEVICE_FRAME_TABLET_HEADER_CIRCLE = '10px';
export const DEVICE_FRAME_MOBILE_HEADER_CIRCLE = '5px';
export const DEVICE_FRAME_CAMERA_SPEAKER_SPACING = '4px';
export const DEVICE_FRAME_BORDER_RADIUS = '6px';
export const FOCUS_RING_BORDER_ALPHA = '.5';
export const FOCUS_RING_SHADOW_ALPHA = '.3';
export const FOCUS_RING_SHADOW_SIZES = '0 0 4px 1px';
export const FOCUS_RING_SHADOW_LAST_SIZES = '0 0 0 1px';